import { Theme } from '@mui/material'

export const menuButtonStyle = ({ isActive, sidebarOpen }: { sidebarOpen: boolean; isActive: boolean }) => ({
	px: '0px',
	margin: sidebarOpen ? '0 8px' : '0 8px 0 8px',
	borderRadius: '8px',
	backgroundColor: isActive ? '#EBEBED' : 'transparent',
	gap: '10px',
	'.MuiListItemIcon-root': {
		display: 'flex',
		justifyContent: 'center',
	},
})

export const logoTextStyle = ({ sidebarOpen }: { sidebarOpen: boolean }) => ({
	opacity: sidebarOpen ? 1 : 0,
	'.MuiTypography-root': {
		fontWeight: 'bold',
		fontSize: '24px',
		fontFamily: '"Eczar", serif',
	},
})

export const listItemTextStyle = (isActive: boolean, sidebarOpen: boolean) => (theme: Theme) => ({
	opacity: sidebarOpen ? 1 : 0,
	color: isActive ? theme.palette.text.darkBlue : 'inherit',
	'.MuiTypography-root': {
		fontSize: '14px',
	},
})

export const iconStyle = (isActive: boolean) => (theme: Theme) => ({
	width: '36px',
	minWidth: 0,
	maxWidth: '100%',
	color: isActive ? theme.palette.text.darkBlue : 'inherit',
})
